module.exports = __webpack_public_path__ + "images/starting-a-business.svg";